import { DocumentStatus } from '~/graphql/__generated__/operations/ltms';

const DICTIONARIES = {
  en: {
    expiry_date_abbr: 'D. Expiry Date',
    expiry_date: 'Document Expiry Date',
    number: 'Document Number',
    type: 'Document Type',
    upload: 'Document Upload',
    link: 'Document Link',
    status_text: 'Document Status',
    status: {
      [DocumentStatus.Uploaded]: 'Uploaded',
      [DocumentStatus.Pending]: 'Pending',
      [DocumentStatus.Expired]: 'Expired',
    },
  },
};

export default DICTIONARIES;
